import React from "react";

export const DotsMenuIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3.375C6.62132 3.375 7.125 2.87132 7.125 2.25C7.125 1.62868 6.62132 1.125 6 1.125C5.37868 1.125 4.875 1.62868 4.875 2.25C4.875 2.87132 5.37868 3.375 6 3.375ZM7.125 6C7.125 6.62132 6.62132 7.125 6 7.125C5.37868 7.125 4.875 6.62132 4.875 6C4.875 5.37868 5.37868 4.875 6 4.875C6.62132 4.875 7.125 5.37868 7.125 6ZM7.125 9.75C7.125 10.3713 6.62132 10.875 6 10.875C5.37868 10.875 4.875 10.3713 4.875 9.75C4.875 9.12868 5.37868 8.625 6 8.625C6.62132 8.625 7.125 9.12868 7.125 9.75Z"
      fill="white"
    />
  </svg>
);

export const IosShareIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7.99984 9.33268V2.66602M10.3332 4.99935L7.99984 2.66602L5.6665 4.99935"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99984 7.33398H3.33317C3.15636 7.33398 2.98679 7.40422 2.86177 7.52925C2.73674 7.65427 2.6665 7.82384 2.6665 8.00065V12.6673C2.6665 12.8441 2.73674 13.0137 2.86177 13.1387C2.98679 13.2637 3.15636 13.334 3.33317 13.334H12.6665C12.8433 13.334 13.0129 13.2637 13.1379 13.1387C13.2629 13.0137 13.3332 12.8441 13.3332 12.6673V8.00065C13.3332 7.82384 13.2629 7.65427 13.1379 7.52925C13.0129 7.40422 12.8433 7.33398 12.6665 7.33398H11.9998"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
